module.exports = __webpack_public_path__ + "media/dashboard/assets/images/opportunity-pipelines/empty-activity-agenda-cdf3c8a86f9506a6d983f4f4d213a244.svg";